import type { Cell } from '@maxgraph/core';

export type CellKind = 'material' | 'operation' | 'flowEdge' | 'group' | 'unknown';

/**
 * Discriminate a maxGraph Cell into a domain kind by inspecting cell.value.kind.
 * Edges are identified by isEdge(); vertices by their value's kind field.
 */
export function classify(cell: Cell): CellKind {
  if (cell.isEdge()) {
    const val = cell.getValue();
    if (val && typeof val === 'object' && val.kind === 'flowEdge') return 'flowEdge';
    return 'flowEdge'; // all edges are flow edges in this domain
  }

  const val = cell.getValue();
  if (!val || typeof val !== 'object') return 'unknown';

  switch (val.kind) {
    case 'material':
      return 'material';
    case 'operation':
      return 'operation';
    case 'group':
      return 'group';
    default:
      return 'unknown';
  }
}
